import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ProfileImageService} from "../../lib/services/profile-image/profile-image.service";
import {NgxImageCompressService} from "ngx-image-compress";
import {ToastService} from "../../lib/services/toast/toast.service";
import {TranslateService} from "@ngx-translate/core";
import {UserUtilsService} from "../../lib/services/user/user-utils.service";
import {PubsubEnum} from "../../lib/enums/pubsub.enum";
import * as pubsub from "pubsub-js"
import {FormBuilder, Validators} from "@angular/forms";
import {StorageKeysEnum} from "../../lib/storage/storage-keys.enum";
import {AuthService} from "../../lib/services/auth/auth.service";
import {PhraseImgSecurityService} from "../../lib/services/save-phrase-img-security/phrase-img-security.service";
import {LoadedImage} from "ngx-image-cropper";
import {AuthenticationService} from "../../lib/services/autenticacion/authentication.service";

@Component({
    selector: 'app-phrase-and-image-register-modal',
    templateUrl: './phrase-and-image-register-modal.component.html',
    styleUrls: ['./phrase-and-image-register-modal.component.scss']
})
export class PhraseAndImageRegisterModalComponent implements OnInit {
    cropper;


    selectedFile!: File | null;
    imageUrl: any;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    dragOver!: boolean;
    translateMessages;
    loading = false;
    userInfo: any;
    phraseImgSecurityForm: any;
    @Output() closeModalEvent: EventEmitter<boolean> = new EventEmitter<boolean>()
    private imageFormat: string;
    @Output() success = new EventEmitter<void>();
    stepChangeImageOptions = {
        UPLOAD_IMAGE: 'UPLOAD_IMAGE',
        CROP_IMAGE: 'CROP_IMAGE'
    }
    stepChangeImage = this.stepChangeImageOptions.UPLOAD_IMAGE;


    constructor(private profileImageService: ProfileImageService,
                private imageCompress: NgxImageCompressService,
                private toastService: ToastService,
                private translateService: TranslateService,
                private formBuilder: FormBuilder,
                private auth: AuthService,
                private phraseImgSec: PhraseImgSecurityService,
                private authentication: AuthenticationService,
                private userUtilsService: UserUtilsService) {
        this.buildForm()
    }

    ngOnInit(): void {
    }

    async closeModal() {
        this.closeModalEvent.emit();
        this.auth.logOut();

    }

    imageCropped(event: any) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
            this.croppedImage = e.target.result;
        };
        reader.readAsDataURL(event.blob);
    }

    imageLoaded(image: LoadedImage) {
        // show cropper
    }

    cropperReady() {
        // cropper ready
    }

    loadImageFailed() {
        // show message
    }

    cropImage() {
        this.compressAndResizeImage(this.croppedImage)
    }

    onDrop(event: DragEvent) {
        event.preventDefault();
        const files = event.dataTransfer?.files;
        if (files && files.length > 0) {
            const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
            const file = files[0];
            if (allowedTypes.includes(file.type)) {
                this.selectedFile = file;
                this.fileToImageSrc();
            } else {
                console.error('Invalid file type. Please drop a PNG, JPEG, or JPG file.');
                this.toastService.showToast(this.translateMessages.errors.typeImage, 'warn')
            }
        } else {
            console.log('Error')
        }
    }

    onDragOver(event: DragEvent) {
        this.dragOver = true
        event.preventDefault();
    }

    onFileSelected(event: any): void {
        this.selectedFile = event.target.files[0];
        this.fileToImageSrc();
    }

    fileToImageSrc() {
        if (this.selectedFile) {
            this.imageFormat = this.selectedFile.type;
            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.imageUrl = e.target.result
            };
            reader.readAsDataURL(this.selectedFile);
            this.stepChangeImage = this.stepChangeImageOptions.CROP_IMAGE
        }
    }

    backBtn() {
        this.stepChangeImage = this.stepChangeImageOptions.UPLOAD_IMAGE;
        this.removeImage()
    }

    compressAndResizeImage(imageToBase64: any) {
        this.imageCompress
            .compressFile(imageToBase64, -1, 80, 80, 80, 80) // -1 for auto quality, 80px x 80px dimensions
            .then((result) => {
                result.replace('data:image/png;base64,', '')
                result.replace('data:image/jpg;base64,', '')
                result.replace('data:image/jpeg;base64,', '')

                this.savePhraseImg(result)
            });
    }

    buildRequest(imageAsBase64) {
        //const base64 = this.imageUrl.replace('data:image/png;base64,', '')
        return {
            personalPhrase: this.phraseImgSecurityForm.value.phraseSecurity,
            avatarImage: imageAsBase64,
            mimeType: 'image/png'//this.imageFormat,
        }
    }

    validOperationResume() {
        this.compressAndResizeImage(this.imageUrl)
    }

    savePhraseImg(imageAsBase64) {
        this.loading = true;
        imageAsBase64 = imageAsBase64.replace('data:image/png;base64,', '')
        imageAsBase64 = imageAsBase64.replace('data:image/jpg;base64,', '')
        imageAsBase64 = imageAsBase64.replace('data:image/jpeg;base64,', '')
        let payload = this.buildRequest(imageAsBase64)
        this.phraseImgSec.savePhraseAndImgSecurity(payload).subscribe({
            next: response => {
                if (sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO) != null && response?.authorizationBanca != null) {
                    sessionStorage.setItem(StorageKeysEnum.ACCESS_TOKEN_WSO, response?.authorizationBanca);
                    pubsub.publish(PubsubEnum.CHANGE_PROFILE_IMAGE);
                    this.userUtilsService.setUserInfoSessionStorage({userImage: 'data:image/png;base64,' + imageAsBase64})
                    this.querySecretWord(response?.authorizationBanca)
                    this.loading = false;
                    this.success.emit()
                } else {
                    this.loading = false;
                    this.toastService.showToast("error", "Error")
                }
            },
            error: err => {
                this.loading = false;
                console.log(err)
                this.toastService.showToast("Error", "error", "Try Again Later")
            }
        })
    }

    buildForm() {
        this.phraseImgSecurityForm = this.formBuilder.group({
            phraseSecurity: ["",
                [
                    Validators.required,
                    Validators.minLength(5),
                    Validators.maxLength(30),
                    Validators.pattern(/^[a-zA-Z0-9\s]+$/)
                ]],
            imageSecurity: ["", [Validators.required]],
        })
    }

    formIsTouched() {
        return this.phraseImgSecurityForm.get('phraseSecurity').touched;
    }


    validationIcon(validatorName: string): string {
        const showIconError = this.phraseImgSecurityForm.get('phraseSecurity').hasError(validatorName);
        return showIconError ? 'assets/images/icons/error-process.png' : 'assets/images/icons/checkmark_success.svg'
    }


    removeImage(): void {
        this.phraseImgSecurityForm.get('imageSecurity')?.reset()
    }


    querySecretWord(accessTokenWSO: any) {
        this.authentication.querySecret(accessTokenWSO).subscribe({
            next: value => {
                this.authentication.setUserPhrase(value?.secret)
            },
            error: err => {
                console.log(err);
                return
            }
        });
    }
}
